(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-studio-hero]').forEach(hero => {
      if (hero.dataset.studioReady) return;
      hero.dataset.studioReady = 'true';
      const video = hero.querySelector('video');
      const toggle = hero.querySelector('.studio-video-toggle');
      if (!video || !toggle) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobileViewport = matchMedia('(max-width: 749px)');
      const connection = navigator.connection;
      let ready = true;
      let inView = false;
      let userPaused = false;
      let userRequested = false;
      let loaded = false;
      const canAutoplay = () => !motion.matches;
      const sync = () => {
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.play : toggle.dataset.pause);
        toggle.setAttribute('aria-pressed', String(!video.paused));
        toggle.querySelector('[data-video-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
      };
      const load = () => {
        if (loaded) return;
        const source = video.querySelector('source[data-src]');
        if (!source) return;
        source.src = mobileViewport.matches && video.dataset.mobileSrc ? video.dataset.mobileSrc : source.dataset.src;
        loaded = true;
        video.load();
      };
      const play = () => { video.muted = true; video.playsInline = true; load(); video.play().catch(sync); };
      const update = () => {
        if (!ready || !inView || document.hidden || userPaused || (!userRequested && !canAutoplay())) {
          video.pause();
          return;
        }
        play();
      };
      toggle.hidden = false;
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('playing', () => hero.classList.add('is-video-ready'));
      video.addEventListener('error', () => {
        hero.classList.remove('is-video-ready');
        userPaused = true;
        sync();
      });
      toggle.addEventListener('click', () => {
        if (video.paused) {
          userPaused = false;
          userRequested = true;
          play();
        } else {
          userPaused = true;
          video.pause();
        }
      });
      motion.addEventListener('change', () => { userRequested = false; update(); });
      const changeFormat = () => {
        video.pause();
        loaded = false;
        hero.classList.remove('is-video-ready');
        update();
      };
      mobileViewport.addEventListener('change', changeFormat);
      connection?.addEventListener('change', () => { userRequested = false; update(); });
      document.addEventListener('visibilitychange', update);
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        update();
      }, {threshold: 0.15});
      observer.observe(hero.querySelector('.cph-focus-film'));
      const bounds = hero.querySelector('.cph-focus-film').getBoundingClientRect();
      inView = bounds.bottom > 0 && bounds.top < window.innerHeight;
      document.addEventListener('pointerdown', update, {once: true, passive: true});
      window.addEventListener('pageshow', update);
      update();
      const unload = event => {
        if (event.target !== hero && !event.target.contains(hero)) return;
        observer.disconnect();
        mobileViewport.removeEventListener('change', changeFormat);
        video.pause();
        document.removeEventListener('visibilitychange', update);
        document.removeEventListener('pointerdown', update);
        window.removeEventListener('pageshow', update);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      sync();
    });
    scope.querySelectorAll('.studio-products').forEach(section => {
      if (section.dataset.studioReady) return;
      section.dataset.studioReady = 'true';
      const move = step => {
        const rail = section.querySelector('[data-pack-panel]:not([hidden]) [data-studio-rail]') || section.querySelector('[data-studio-rail]');
        const card = rail?.querySelector('.studio-card');
        if (!rail || !card) return;
        const direction = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({left: step * direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      section.querySelector('[data-rail-prev]').addEventListener('click', () => move(-1));
      section.querySelector('[data-rail-next]').addEventListener('click', () => move(1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
